export const productList = [
  {
    id: '1',
    name: '工业互联网+安全生产',
    content: '工业互联网+安全生产',
    icon: '/images/menu/menu-p-1.png',
    list: [
      {
        id: '1-1',
        name: '企业安全风险管控平台',
        list: [
          {
            id: '1-1-1',
            type: 2,
            name: '企业安全风险管控平台',
            menuIcon: '/images/menu/prod/icon-2-1-5.png',
            des: '提升安全生产管理的可预测、可管控水平',
            icon: '/images/product/pd-1-1-1/11.png',
            content: '以信息化促进企业数字化、智能化转型升级，建设集重大危险源、双重预防、特殊作业、人员在岗在位管理、智能视频监控、企业生产全流程管理于一体的安全生产信息化管理平台，推动操作控制智能化、风险预警精准化、危险作业流程化，提升安全生产管理的可预测、可管控水平。强化企业快速感知、实时监测、超前预警、动态优化、智能决策、联动处置、系统评估、全局协同能力，打造企业工业互联网新基础设施，建设企业与园区节点对接，全面提升企业安全生产管理水平',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['以信息化促进企业数字化、智能化转型升级，建设集重大危险源、双重预防、特殊作业、人员在岗在位管理、智能视频监控、企业生产全流程管理于一体的安全生产信息化管理平台，推动操作控制智能化、风险预警精准化、危险作业流程化，提升安全生产管理的可预测、可管控水平。强化企业快速感知、实时监测、超前预警、动态优化、智能决策、联动处置、系统评估、全局协同能力，打造企业工业互联网新基础设施，建设企业与园区节点对接，全面提升企业安全生产管理水平']
                  }
                ]
              },
              {
                title: '建设依据',
                haveBg: true,
                list: [
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '《“工业互联网+危化安全生产”特殊作业许可与作业过程管理系统建设应用指南（试行）》',
                        content: '作为流程工业，在危险化学品领域推动工业互联网、大数据、人工智能（AI）等新一代信息技术与安全管理深度融合，是推进危险化学品安全治理体系和治理能力现代化的重要战略选择，对于推进危险化学品安全管理数字化、网络化、智能化，高效推动质量变革、效率变革、动力变革，具有十分积极的意义。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/1.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（2）',
                        title: '危险化学品企业安全风险智能化管控平台建设指南（试行）',
                        content: '危险化学品企业安全风险智能化管控平台建设坚持以有效防范化解重大安全风险为目标，突出安全基础管理、重大危险源安全管理、安全风险分级管控和隐患排查治理双重预防机制（以下简称双重预防机制）、特殊作业许可与作业过程管理、智能巡检、人员定位等基本功能，打造企业“工业互联网+危化安全生产”新基础设施建设，推动企业安全基础管理数字化、风险预警精准化、风险管控系统化、危险作业无人化、运维辅助远程化，为实现危险化学品企业安全风险管控数字化转型智能化升级注入新动能。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/2.png',
                    ]
                  }
                ]
              },
              {
                title: '现状分析',
                list: [
                  {
                    type: 'order',
                    model: 3,
                    list:[
                      {
                        index: '1',
                        title: '',
                        content: '主体责任不落实、认识不到位'
                      },
                      {
                        index: '2',
                        title: '',
                        content: '管理人员重视度不够'
                      },
                      {
                        index: '3',
                        title: '',
                        content: '员工安全意识淡薄'
                      },
                      {
                        index: '4',
                        title: '',
                        content: '违规操作情况较多'
                      },
                      {
                        index: '5',
                        title: '',
                        content: '化工生产监管力度不足'
                      },
                      {
                        index: '6',
                        title: '',
                        content: '培训教育不到位'
                      },
                      {
                        index: '7',
                        title: '',
                        content: '缺少体系化的安全管理系统'
                      },
                      {
                        index: '8',
                        title: '',
                        content: '应急管理能力普遍不高'
                      }
                    ]
                  }
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '重大危险源管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['接入企业各种安全生产动态监测数据、监控视频，内嵌视频智能分析及预测预警模型，助力企业提升事故预警能力']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/3.png',
                      '/images/product/pd-1-1-1/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '风险分级管控评估'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['通过生产过程危险和有害因素的辨识，运用定性或定量的统计分析方法确定其风险程度']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '巡查巡检'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['协助企业实现安全检查移动数字化和隐患排查治理的监管全过程']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['针对企业涉及风险的八大特殊作业进行作业申请、作业审批、作业处理等全流程管控。']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/7.png',
                      '/images/product/pd-1-1-1/8.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '生产安全事故记录'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['分析记录园区近5年内危险化学品事故和其他事故总体分析以及各事故类型、人员伤亡、事故原因和事故处理、采取的对策措施等']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '设备状态诊断'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['在设备日常运行维护和检修管理当中，实时监测设备的运行状态、检修决策状态以及故障因素等']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/10.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '人员在岗在位'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['用于管理化工企业作业人员定时、定人、定岗履职的物联网信息系统']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/11.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '企业档案管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['对企业基本信息、分区/重大危险源/风险点详情、车辆人员以及仓储等信息的综合记录展示']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/12.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['管理建立应急资源数据，保障应急资源的可用性及应急预案的可操作性']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/13.png',
                      '/images/product/pd-1-1-1/14.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '智能视频管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['对企业的各个区域多种违规行为进行查看识别和预警']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/15.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '安全教育培训'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['以信息化手段，助力企业安全教育培训，促进企业安全生产管理措施的持续改进']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-1/16.png',
                    ]
                  }
                ]
              },
              {
                title: '部署方式',
                list: [
                  {
                    type: 'row-col',
                    colSpan: 12,
                    list: [
                      {
                        title: 'SaaS',
                        list: [
                          '云服务器',
                          '无需购买软件和硬件，无需IT维护',
                          '前期投资成本低',
                          '系统自动更新，可免费享受最新功能',
                          '按年付费，快速部署'
                        ]
                      },
                      {
                        title: '本地部署',
                        list: [
                          '自建服务器，数据存储在本地',
                          '软件永久授权',
                          '个性化需求定制程度更高',
                          '灵活性和自主性更高'
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            id: '1-1-2',
            name: '重大危险源管理',
            menuIcon: '/images/menu/prod/icon-1-1-2.png',
            des:'有效防范较大事故，坚决遏制重特大事故',
            icon: '/images/product/pd-1-1-2/sol-3-info.png',
            content:'监控管理平台可以监管辖区内全部危化企业的生产、储存等状况，也可以查询各企业所有的历史数据，同时可以通过网络对企业重大危险源发生的事故进行重大危险源应急处理预案的实施和指挥',
            path: '/bigDanger', // 2是单独页面
            list:[]
          },
          {
            id: '1-1-3',
            name: '双重预防机制',
            menuIcon: '/images/menu/prod/icon-1-1-3.png',
            des:'构建“控风险、治隐患”的安全管理闭环，降低事故发生率',
            icon: '/images/case2/pd-1-1-3-1.png',
            content:'双重预防机制模块主要涵盖了安全风险分区管理和企业隐患排查治理两个部分的内容。安全风险分区功能通过生产过程危险和有害因素的辨识，运用定性或定量的统计分析方法确定其风险程度，一般分为重大风险、较大风险、一般风险、低风险，在信息系统中企业厂区平面图上用红、橙、黄、蓝“四色图”进行标绘，形成“两单三卡”。隐患排查治理功能包括隐患排查计划、任务、登记、整改等内容，在移动端和PC端都可以进行操作。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['双重预防机制模块主要涵盖了安全风险分区管理和企业隐患排查治理两个部分的内容。安全风险分区功能通过生产过程危险和有害因素的辨识，运用定性或定量的统计分析方法确定其风险程度，一般分为重大风险、较大风险、一般风险、低风险，在信息系统中企业厂区平面图上用红、橙、黄、蓝“四色图”进行标绘，形成“两单三卡”。隐患排查治理功能包括隐患排查计划、任务、登记、整改等内容，在移动端和PC端都可以进行操作。 ']
                  }
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '风险分析对象管理'
                  },
                  {
                    type: 'content',
                    list: ['将企业的重大危险源进行识别、分级和划分，设置为风险分析对象和风险分析单元。对重大危险源进行责任落实监督、在线监测预警、对罐区、气体等重大风险进行实时监测、重大风险管控、评价/评估报告管理及隐患管理和重大危险源企业分类监管。 ']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/case2/pd-1-1-3-1.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '风险辨识评估'
                  },
                  {
                    type: 'content',
                    list: ['通过对分区固有风险评估和重大危险源控制风险评估对分区进行等级判断。']
                  },
                  {
                    type: 'content',
                    list: ['风险评估方式：']
                  },
                  { // 无序排列
                    type: 'disorder',
                    model:2,
                    list: [
                      '安全检查表-SCL',
                      '工作危害分析-JHA',
                      '故障类型和影响分析-FMEA',
                      '危险和可操作性分析-HAZOP',
                      '预先危险性分析法-PHA'
                    ]
                  },
                  {
                    type: 'content',
                    list: ['风险等级：']
                  },
                  { // 无序排列
                    type: 'disorder',
                    model:2,
                    list: [
                      'A 级：重大风险',
                      'B 级：较大风险；',
                      'C 级：一般风险；',
                      'D 级：低风险。'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-3/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '风险分级管控'
                  },
                  { // 无序排列
                    type: 'disorder',
                    list: [
                      '按照事故发生的可能性和事故后果严重性，风险分区采用LS评价法、风险矩阵法等方法对危险源进行风险分级，确定安全风险等级。',
                      '从高到低依次划分为重大风险、较大风险、一般风险和低风险四级，分别采用红、橙、黄、蓝四种颜色标示。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-3/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '隐患排查治理'
                  },
                  {
                    type: 'content',
                    list: ['对企业进行厂区安全巡检，首先制定排查标准和设备排查库，制定隐患排查计划，执行隐患排查，对隐患进行确认、整改和复查；支持隐患随手拍的记录方式，多种途径管控企业的安全。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-3/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '巡查巡检'
                  },
                  {
                    type: 'content',
                    list: ['分析企业的安全风险点，进行巡检项、巡查点的维护，制定巡查计划，并执行巡查计划生成的巡查任务，支持多种时间频度的任务，全方位保障企业安全。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-3/5.png',
                    ]
                  }
                ]
              }
            ]
          },
          {
            id: '1-1-4',
            name: '特殊作业过程管理',
            menuIcon: '/images/menu/prod/icon-1-1-4.png',
            des:'实现特殊作业全过程的规范化、程序化管理',
            icon: '/images/product/pd-1-1-4/7.png',
            content:'特殊作业：基于《GB 30871-2014 化学品生产单位特殊作业安全规范》标准，采用信息化技术，对动火、受限空间、盲板抽堵、高处、吊装、临时用电、动土、断路等特殊作业的申请、审查、许可、监护、验收等全过程实行信息化管理，应用视频监控设备对作业全过程进行实时监控和视频存储，还可应用智能视频监控系统对作业过程异常状态进行智能分析、监测报警，实现特殊作业全过程的规范化、程序化管理。 ',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['特殊作业：基于《GB 30871-2014 化学品生产单位特殊作业安全规范》标准，采用信息化技术，对动火、受限空间、盲板抽堵、高处、吊装、临时用电、动土、断路等特殊作业的申请、审查、许可、监护、验收等全过程实行信息化管理，应用视频监控设备对作业全过程进行实时监控和视频存储，还可应用智能视频监控系统对作业过程异常状态进行智能分析、监测报警，实现特殊作业全过程的规范化、程序化管理。 ']
                  }
                ]
              },
              {
                title: '建设依据',
                haveBg: true,
                list: [
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '《“工业互联网+危化安全生产”特殊作业许可与作业过程管理系统建设应用指南（试行）》',
                        content: '“通过特殊作业许可与作业过程管理系统的建设，将特殊作业审批许可条件目化、电子化、流程化，并通过信息化手段对作业全程进行过程和痕迹'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-4/1.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（2）',
                        title: '《危险化学品企业特殊作业安全规范》 （GB30871）',
                        content: '聚焦动火、受限空间等事故多发作业类型，明确了企业应建立作业前许可管理制度，制定重大风险管控措施，强化逐级审批和作业监护的要求。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-4/2.png',
                    ]
                  }
                ]
              },
              {
                title: '平台功能',
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '八大特殊作业类型全覆盖'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['动火、受限空间、盲板抽堵、高处、吊装、临时用电、动土、断路等特殊作业的申请、审查、许可、监护、验收等全过程实行信息化管理']
                  },
                  {
                    type: 'img',
                    imgType: 3,
                    colSpan: 8,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-4/3.png',
                      '/images/product/pd-1-1-4/4.png',
                      '/images/product/pd-1-1-4/5.png',
                      '/images/product/pd-1-1-4/6.png',
                      '/images/product/pd-1-1-4/7.png',
                      '/images/product/pd-1-1-4/8.png',
                      // '/images/product/pd-1-1-4/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '现场作业标准化'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['提供八大标准作业票格式，支持作业自主申请，作业内容记录全程留痕。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-4/10.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '办票过程可视化'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统实施记录所有办票环节，严格记录作业申请、措施确认、会签审批等各个环节的确认人及签批时间']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-4/11.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '管理执行规范化'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['通过对作业环节承包商以及作业人员的管理督促企业提升人员管控力度，规范承包商企业及人员行为，规范现场施工过程中人员管理。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-4/12.png',
                    ]
                  }
                ]
              }
            ]
          },
          {
            id: '1-1-5',
            name: '人员在岗在位管理',
            menuIcon: '/images/menu/prod/icon-1-1-5.png',
            des:'实现特殊作业全过程的规范化、程序化管理',
            icon: '/images/product/pd-1-1-5/2.png',
            content:'人员在岗在位：用于管理化工企业作业人员定时、定人、定岗履职的物联网信息系统，可通过生物识别、智能门禁、实时定位等技术，提供人员及车辆定位管理功能，包括基本信息查询、移动轨迹追踪、行动轨迹回放等，针对人员在岗、离岗、串岗人员及车辆越界、滞留等情况提供及时告警，实时获取现场信息。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['人员在岗在位：用于管理化工企业作业人员定时、定人、定岗履职的物联网信息系统，可通过生物识别、智能门禁、实时定位等技术，提供人员及车辆定位管理功能，包括基本信息查询、移动轨迹追踪、行动轨迹回放等，针对人员在岗、离岗、串岗人员及车辆越界、滞留等情况提供及时告警，实时获取现场信息。']
                  }
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '人员基本信息管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统应具备对企业人员信息管理等功能，包括人员单位名称、姓名、年龄、工种、培训情况等，同时对访客等其他人员信息进行管理']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-5/1.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '人员实时位置显示'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统实时显示生产、储存区域人员数量，实时在地图上显示人员位置，可穿透查看人员详细信息以及分区域、分类别显示统计数量']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-5/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '人员历史轨迹查看'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统可存储至少30天的人员位置信息与时间点信息，形成运动轨迹，实现人员历史轨迹查询功能。历史轨迹功支持多天查询，完整展示出人员活动范围']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-5/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '电子围栏+异常报警'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统支持设置电子围栏功能，可在内厂区电子地图上圈定电子围栏范围，设定围栏生效时间、限定人数等功能。同时，具备异常情况报警、推送、处置、确认功能']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-5/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '辅助应急'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统支持一键报警求救功能，当人员在生产区域内遇到紧急情况，可通过随身携带的定位设备即时发出报警信号，救援人员可快速确定人员位置']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-5/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '统计分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['系统支持分类统计进入生产厂区或者特定区域的人员数量的功能，有条件的企业应设置智能门禁系统并与人员自动定位系统相关联']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-1-1-5/6.png',
                    ]
                  }
                ]
              }
            ]
          },
          {
            id: '1-1-6',
            name: '安全生产培训',
            menuIcon: '/images/menu/prod/icon-1-1-6.png',
            des:'实现特殊作业全过程的规范化、程序化管理',
            icon: '/images/product/pd-1-1-6/icon-6.png',
            content:'实现安全生产培训的信息化，建设企业安全培训资源库，实现资源推送、在线培训、在线考试等功能，增强员工责任心及防范意识、企业价值',
            path:'/prdTrain',
            list: []
          }
        ]
      }
    ]
  },
  {
    id: '2',
    name: '工业互联网+园区管控',
    content: '工业互联网+园区管控',
    icon: '/images/menu/menu-p-2.png',
    list: [
      {
        id: '2-1',
        name: '园区安全风险智能化管控',
        list: [
          {
            id: '2-1-1',
            type: 2,
            name: '园区安全风险智能化管控平台',
            menuIcon: '/images/menu/prod/icon-2-1-1.png',
            des: '强化感知、网络、安全等基础设施建设，实现园区可持续发展',
            icon: '/images/product/pd-2-1-1/2.png',
            content:'化工园区安全风险智能化管控平台建设坚持以有效防范化解重大安全风险为目标，突出安全基础管理、重大危险源安全管理、安全风险分级管控和隐患排查治理双重预防机制、特殊作业管理、封闭化管理和敏捷应急等基本功能，强化感知、网络、安全等基础设施建设，推进信息共享、上下贯通，推动科技创新、工业互联网产业生态、安全生产在园区内外的渗透及融合发展，实现不同企业、不同部门、不同层级之间的协同联动，助力化工园区安全发展、高质量发展。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['化工园区安全风险智能化管控平台建设坚持以有效防范化解重大安全风险为目标，突出安全基础管理、重大危险源安全管理、安全风险分级管控和隐患排查治理双重预防机制、特殊作业管理、封闭化管理和敏捷应急等基本功能，强化感知、网络、安全等基础设施建设，推进信息共享、上下贯通，推动科技创新、工业互联网产业生态、安全生产在园区内外的渗透及融合发展，实现不同企业、不同部门、不同层级之间的协同联动，助力化工园区安全发展、高质量发展。']
                  }
                ]
              },
              {
                title: '建设依据',
                haveBg: true,
                list: [
                  {
                    type: 'order2',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '国务院安全生产“十四五”规划',
                        content: [
                          '强化高危化学品和高危工艺风险管控，升级重大危险源风险监测预警系统。',
                          '推动危险化学品安全数字化智能化转型。',
                          '引导高危行业领域企业开展基于信息化的安全风险分级管控和隐患排查治理双重预防机制建设。'
                        ]
                      },
                      {
                        index: '（2）',
                        title: '国务院危化安全治理方案通知（[2016]88号）',
                        content: [
                          '推动利用信息化、智能化手段在化工园区和涉及危险化学品重大风险功能区建立安全、环保、应急救援一体化管理平台推进加强化工园区和涉及危险化学品重大风险功能区及危险化学品罐区的风险管控',
                        ]
                      },
                      {
                        index: '（3）',
                        title: '国务院安委办、应急部关于推进危化品安全风险监测预警系统的指导意见（安委办【2019】1号）',
                        content: [
                          '2019年10月底，河北省、山东省、江苏省、广东省等危险化学品重点地区建设完成省级危险化学品检测遇见系统，接入辖区内一、二级重大危险源企业重点监测监控预警数据。',
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                title: '平台特点',
                list: [
                  {
                    type: 'content',
                    model: 1,
                    list: ['化工园区安全风险智能化管控平台主体采用B/S架构，以及主流、开放的平台应用框架，满足可靠、集成、兼容、可扩展、可维护、安全等性能要求，支撑化工园区安全风险管控的信息化数字化应用需求。符合但不限于以下要求：']
                  },
                  { // 无序排列
                    type: 'disorder',
                    model:2,
                    list: [
                      '业务流程覆盖，支持实现本指南要求的基本功能；',
                      '功能模块化设计，各模块可单独使用；',
                      '集成性，提供开放接口，便于与化工园区内企业、其他职能部门及上级政府应急管理部门信息系统对接集成；',
                      '兼容性，注重融合化工园区现有信息系统，实现功能互补，数据互联互通；',
                      '可扩展性，园区根据自身建设要求，完成基本建设内容，还可以扩展创新应用和场景；',
                      '支持跨平台、跨系统运行，支持大屏、电脑端和移动设备；',
                      '数据标准化，规范各类信息资源元数据和编码规则，统一数据处理机制。',
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '总体结构'
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/1.png',
                      '/images/product/pd-2-1-1/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '安全基础管理'
                  },
                  {
                    type: 'content',
                    list: ['建立园区基础信息库，包含园区规划、企业管理、安全生产行政许可证管理，开停车和大检修管理、执法管理、第三方单位管理等信息。支持信息维护和快速查询。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '重大危险源安全管理'
                  },
                  {
                    type: 'content',
                    list: ['主要实现重大危险源的安全包保责任落实监督、在线监测预警、重大风险管控、评价/评估报告管理及隐患管理和重大危险源企业分类监管。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '双重预防机制'
                  },
                  {
                    type: 'content',
                    list: ['双重预防机制主要用于实现与企业双重预防机制信息系统对接、双重预防机制建设及运行效果抽查检查和隐患整改情况督办提醒等，推动企业有效运行双重预防机制，提升安全风险防控水平。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业管理'
                  },
                  {
                    type: 'content',
                    list: ['主要用于园区内企业特殊作业的报备、统计分析、线上抽查检查，有效防范化解特殊作业安全风险。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '封闭化管理'
                  },
                  {
                    type: 'content',
                    list: ['通过封闭化建设，规范和优化出入园区的人流、物流和车流行驶路径，全过程监管出入园区的人员、车辆、货物，防止外来输入风险，有效管控园区安全风险，提高园区事故预防和应急管理能力。']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/7.png',
                      '/images/product/pd-2-1-1/8.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '敏捷应急'
                  },
                  {
                    type: 'content',
                    list: ['主要用于安全生产应急预案管理、应急辅助决策、应急演练管理、应急资源管理、应急指挥调度，推动园区、企业落实日常应急管理及与各级政府间的应急联动，为事故应急提供技术支持，辅助园区进行快速、精准、科学应急响应。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-1/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '智能AI视频'
                  },
                  {
                    type: 'order',
                    model: 4,
                    list:[
                      {
                        index: '',
                        title: '火焰智能监测：',
                        content: '监测识别区域内烟雾和火焰，将报警信息及时推送给企业。'
                      },
                      {
                        index: '',
                        title: '通道堵塞智能监测：',
                        content: '监测预警厂区道路及车间仓库消防通道堵塞情况。'
                      },
                      {
                        index: '',
                        title: '人员离岗智能监测：',
                        content: '监测预警厂区内人员发生离岗违规行为。'
                      },
                      {
                        index: '',
                        title: '人员聚集智能监测：',
                        content: '监测预警厂区内人员发生聚集违规行为。'
                      },
                      {
                        index: '',
                        title: '人员入侵智能监测：',
                        content: '监测预警在重点危险区域特定时间人员违规进入行为。'
                      },
                      {
                        index: '',
                        title: '越界检测：',
                        content: '监测风险分区划定界限内人员闯入报警。'
                      },
                      {
                        index: '',
                        title: '翻越围栏：',
                        content: '监测预警可疑人员靠近或攀越围栏行为。'
                      },
                      {
                        index: '',
                        title: '安全帽识别：',
                        content: '监测厂区人员未佩戴安全帽行为报警。'
                      },
                      {
                        index: '',
                        title: '抽烟识别：',
                        content: '监测厂区禁烟区人员抽烟行为。'
                      },
                      {
                        index: '',
                        title: '打电话识别：',
                        content: '监测厂区内违规打电话行为。'
                      },
                      {
                        index: '',
                        title: '电瓶车入梯：',
                        content: '监测告警电瓶车入梯行为。'
                      },
                      {
                        index: '',
                        title: '车辆监测：',
                        content: '监测厂区禁停区域内出现车辆违停行为。'
                      },
                      {
                        index: '',
                        title: '垃圾满溢：',
                        content: '监测报警厂区废料等垃圾溢出行为。'
                      },
                      {
                        index: '',
                        title: '监控室脱岗检测：',
                        content: '自动识别监控室无工作人员的情况。'
                      },
                      {
                        index: '',
                        title: '楼道杂物堆放识别：',
                        content: '监测识别楼道或安全通道中杂物堆放的情况。'
                      }
                    ]
                  },
                  
                ]
              },
              {
                title: '部署方式',
                list: [
                  {
                    type: 'row-col',
                    colSpan: 12,
                    list: [
                      {
                        title: 'SaaS',
                        list: [
                          '云服务器',
                          '无需购买软件和硬件，无需IT维护',
                          '前期投资成本低',
                          '系统自动更新，可免费享受最新功能',
                          '按年付费，快速部署'
                        ]
                      },
                      {
                        title: '本地部署',
                        list: [
                          '自建服务器，数据存储在本地',
                          '软件永久授权',
                          '个性化需求定制程度更高',
                          '灵活性和自主性更高'
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                title: '平台设备',
                haveBg: true,
                list: [
                  { // 无序排列
                    type: 'disorder',
                    model: 1,
                    list: [
                      'GPS定位终端',
                      '视频摄像头',
                      '出入园管理系统（闸机、定位卡、门禁）',
                    ]
                  },
                ]
              },
              {
                title: '平台优势',
                list: [
                  {
                    type: 'content',
                    list: [
                      '为园区提供工作协同和统一管理工具，致力于以简洁高效的方式解决园区管理繁杂、效率低下的问题。结合园区原有线下工作流程，根据标准流程，如装修流程、物业报修、保安巡更、保洁流程、绿化流程等，配置标准化工作模板，打造园区专属任务系统。此外，搭配智能物联平台，建立门禁系统、车禁系统，实现人、物、车全面互联。智能物联管理平台还可以对现有的能源消耗进行统计，并提出节能方案，构建全新的商业模式和服务形态。',]
                  },
                ]
              }
            ]
          },
          {
            id: '2-1-2',
            name: '安全基础管理',
            menuIcon: '/images/menu/prod/icon-2-1-2.png',
            des:'建立园区基础信息库，对园区信息进行统一管理',
            icon: '/images/product/pd-2-1-2/1.png',
            content:'建立园区基础信息库，包含：“禁限控”目录、园区内化工企业基本情况以及“两重点一重大”、从业人员、值班值守、企业事故事件等信息。支持信息维护和快速查询，以及相关数据多维度统计分析和可视化展示。',
            list: [
              {
                title: '平台功能',
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '园区管理（一园一策）'
                  },
                  {
                    type: 'content',
                    list: ['建立园区基础信息库，包含：“禁限控”目录、园区内化工企业基本情况以及“两重点一重大”、从业人员、值班值守、企业事故事件等信息。支持信息维护和快速查询，以及相关数据多维度统计分析和可视化展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-2/1.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '企业管理（一企一档）'
                  },
                  {
                    type: 'content',
                    list: ['对园区企业信息及后期新建企业信息进行统一管理，包含企业基础信息、安监档案、员工信息、车间信息、仓库信息、储罐信息、有限空间、物料信息、重大危险源、危险工艺、反应风险评估、化学能源、汇总统计、应急资源档案、设备管理档案等。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-2/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '安全生产行政许可管理'
                  },
                  {
                    type: 'content',
                    list: ['园区危险化学品管理，实现“三同时”和安全生产许可相关证照材料线上提报、审核、查阅等全流程监管功能。支持危险化学品建设项目“三同时”管理流程和安全生产许可流程灵活配置，以及按类别、“三同时”阶段、许可证类型等多维度统计分析和可视化展示。支持与各地区现有行政许可审批系统对接。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '装置开停车和大检修管理'
                  },
                  {
                    type: 'content',
                    list: ['实现园区内企业装置设施（含重大危险源）开停车和大检修线上备案，备案内容包含装置开停车方案和时间、大检修方案和时间等。支持备案信息维护、查询，以及开停车、大检修数据等多维度统计分析和可视化展示。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '第三方单位管理'
                  },
                  {
                    type: 'content',
                    list: ['建立入园/驻园第三方单位信息库，包括第三方单位基本信息、资质、安全教育培训记录、服务记录、违规记录等，实现第三方单位诚信管理。支持信息维护、核验，诚信评价规则的在线配置，以及园区企业对有关信息的自主填报。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '执法管理'
                  },
                  {
                    type: 'content',
                    list: ['按照应急管理部“互联网+执法”系统建设要求，化工园区智能化管控平台生成执法计划、记录执法内容、生成和下发执法文书、跟踪企业整改闭环全流程管理。平台支持移动终端执法留痕，相关法律法规标准规范数据库关键字检索，执法案例智能推送，以及执法信息快速查询、统计分析和可视化展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-2/3.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id: '2-1-3',
            name: '重大危险源管理',
            menuIcon: '/images/menu/prod/icon-2-1-3.png',
            des:'提醒企业及时进行应急处置，降低事故发生率',
            icon: '/images/product/pd-2-1-3/1.png',
            content:'实现对涉及危险化学品重大危险源、重点监管危险化工工艺、重点监管危险化学品生产、储存、使用场所，利用物联网、信息化等技术手段实现重要安全参数（温度、压力、液位、可燃气体浓度、有毒气体浓度、视频等）的在线监测预警，提升园区对重大危险源的动态监管能力，使园区及时发现重点危险场所、关键装置事故风险隐患，提醒企业及时进行应急处置，降低事故发生率。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['实现对涉及危险化学品重大危险源、重点监管危险化工工艺、重点监管危险化学品生产、储存、使用场所，利用物联网、信息化等技术手段实现重要安全参数（温度、压力、液位、可燃气体浓度、有毒气体浓度、视频等）的在线监测预警，提升园区对重大危险源的动态监管能力，使园区及时发现重点危险场所、关键装置事故风险隐患，提醒企业及时进行应急处置，降低事故发生率。 ']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-3/1.png',
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'content',
                    model:2,
                    list: ['主要实现重大危险源的安全包保责任落实监督、在线监测预警、重大风险管控、评价/评估报告管理及隐患管理和重大危险源企业分类监管。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '重大危险源安全包保责任落实监督'
                  },
                  {
                    type: 'content',
                    list: ['园区平台实现重大危险源安全包保履职记录电子化、条目化，管理企业每一处重大危险源包保责任落实情况，支持重大危险源主要负责人、技术负责人和操作负责人信息维护，三级包保责任人安全包保履职情况记录检查，以及信息查询、多维度统计分析功能。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-3/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '在线监测预警'
                  },
                  {
                    type: 'content',
                    list: ['通过实时监测与抽查，汇聚现有重大危险源监测监控数据，实现对重大危险源安全在线抽查。支持基于GIS地图的重大危险源浏览，查看储罐、装置、危险化学品库等处的液位、温度、压力和可燃有毒气体浓度的实时监测据、报警数据，支持查询历史数据和对比分析。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-3/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '重大风险管控'
                  },
                  {
                    type: 'content',
                    list: ['基于风险预警模型，分为重大风险（红）、较大风险（橙）、一般风险（黄）、低风险（蓝）四个级别。实现重大危险源安全风险的实时评估分析和展示。支持根据预警级别，按照《危险化学品安全生产风险监测预警系统预警信息处置管理办法（试行）》，即时自动完成预警信息的发送、核查、反馈和督办。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-3/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '评价/评估报告及隐患管理'
                  },
                  {
                    type: 'content',
                    list: ['汇聚重大危险源的安全评价报告、SIL等级评估报告和重大危险源专项督导检查问题隐患相关数据，实现重大危险源的安全评价报告电子化备案、查阅和问题隐患“三录入”、整改反馈，支持精确和模糊查询、多维度统计分析及可视化展示。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '重大危险源企业分类监管'
                  },
                  {
                    type: 'content',
                    list: [
                      '贯通安全承诺公告、实时监测数据、安全包保责任人履职、“三录入”、评价/评估报告，基于危险化学品重大危险源企业安全管理现状综合评价体系，分为特别管控、重点关注和一般监管三类，实现对危险化学品重大危险源企业分类精准监管，支持基于GIS地图分类标注、多维度统计分析及可视化展示。',
                      '实现区域内重大危险源数量统计和位置分布展示，按照行政区划、重大危险源分级、企业所属行业、企业类型等维度查询区域内重大危险源数量和重大危险源分布情况。'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-3/5.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id: '2-1-4',
            name: '双重预防机制管理',
            menuIcon: '/images/menu/prod/icon-2-1-4.png',
            des:'推动企业有效运行双重预防机制，提升安全风险防控水平',
            icon: '/images/product/pd-2-1-4/1.png',
            content:'双重预防机制主要用于实现与企业双重预防机制信息系统对接、双重预防机制建设及运行效果抽查检查和隐患整改情况督办提醒等，推动企业有效运行双重预防机制，提升安全风险防控水平。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '双重预防机制主要用于实现与企业双重预防机制信息系统对接、双重预防机制建设及运行效果抽查检查和隐患整改情况督办提醒等，推动企业有效运行双重预防机制，提升安全风险防控水平。',
                      '企业双重预防机制建设及运行效果抽查检查实现对园区内企业双重预防机制运行效果线上线下相融合的监督检查，支持对单个企业风险分析完成率、排查任务完成率及隐患整改完成率的信息查询，对企业双重预防机制运行效果、隐患预警情况自动统计分析、原因分析，通过短信等方式定期推送给有关人员，为线下精准执法检查提供支撑。'
                    ]
                  }
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '企业双重预防机制信息系统对接'
                  },
                  {
                    type: 'content',
                    list: ['园区平台支持层层穿透到企业端双重预防机制信息系统，查看企业生产装置/罐区、风险事件数量、隐患数量等基本信息，并可查询企业风险分级管控清单和隐患排查清单。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-4/1.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '安全风险分级管控'
                  },
                  {
                    type: 'content',
                    list: ['（1）划分安全风险分析单元：按照“功能独立、大小适中、易于管理”的原则，选取所有生产装置、储存设施或场所作为安全风险分析对象。按照《危险化学品重大危险源辨识》（GB18218）规定，构成重大危险源的应独立作为安全风险分析对象。']
                  },
                  {
                    type: 'content',
                    list: ['（2）绘制安全风险空间分布图：企业应依据安全风险评价准则，对安全风险分析对象固有安全风险与分析单元内风险点控制风险进行科学分级，从高到低依次划分为重大安全风险、较大安全风险、一般安全风险和低安全风险4个等级，分别采用红、橙、黄、蓝四种颜色进行标示，并在信息系统中绘制安全风险空间分布图。']
                  },
                  {
                    type: 'content',
                    list: ['（3）制定管控措施：针对安全风险事件，企业应从工程技术、维护保养、人员操作、应急措施等方面识别评估现有管控措施的有效性。']
                  },
                  {
                    type: 'content',
                    list: ['（4）实施风险管控：企业根据安全风险事件可能造成的后果严重程度，明确对应的企业、部门、车间、班组、岗位人员分级管控的范围和责任，将责任分解到各层级岗位，确保安全风险管控措施有效实施。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-4/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '隐患排查治理'
                  },
                  {
                    type: 'content',
                    list: ['主要用于实现园区平台与企业双重预防机制信息系统对接、双重预防机制建设及运行效果抽查检查和隐患整改情况督办提醒等，推动企业有效运行双重预防机制，提升安全风险防控水平。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-4/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '隐患整改情况督办提醒'
                  },
                  {
                    type: 'content',
                    list: ['园区平台可实现制定检查计划、方案，现场导出检查记录、现场处理措施决定书、责令限期整改指令书、整改复查意见书等文书。实现对重大隐患线上督办、整改临期提醒及一般隐患超期警示功能，支持线上下发督办通知书、通过短信向有关人员发送提醒警示信息等功能，确保实现隐患闭环处置，以及不同行业、不同关键装置隐患多维度统计分析和可视化展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-4/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '企业双重预防机制建设及运行效果抽查检查'
                  },
                  {
                    type: 'content',
                    list: ['实现对园区内企业双重预防机制运行效果线上线下相融合的监督检查，支持对单个企业风险分析完成率、排查任务完成率及隐患整改完成率的信息查询，对企业双重预防机制运行效果、隐患预警情况自动统计分析、原因分析，通过短信等方式定期推送给有关人员，为线下精准执法检查提供支撑。']
                  }
                ]
              }
            ]
          },
          {
            id: '2-1-5',
            name: '特殊作业管理',
            menuIcon: '/images/menu/prod/icon-2-1-5.png',
            des:'用于园区内企业特殊作业报备、分析等，有效防范化解特殊作业安全风险',
            icon: '/images/product/pd-2-1-5/1.png',
            content:'园区特殊作业管理采用信息化技术，对企业的动火、受限空间、盲板抽堵、高处、吊装、临时用电、动土、断路等特殊作业的申请、审查、许可、监护、验收等全过程实行信息化管理，应用视频监控设备对作业全过程进行实时监控和视频存储，还可应用智能视频监控系统对作业过程异常状态进行智能分析、监测报警，实现特殊作业全过程的规范化、程序化管理。特殊作业全过程信息化管理系统应实现作业计划预约申请、开具电子作业票证、过程安全控制、验收归档、统计分析等功能。参照《GB 30871-2014 化学品生产单位特殊作业安全规范》。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '园区特殊作业管理采用信息化技术，对企业的动火、受限空间、盲板抽堵、高处、吊装、临时用电、动土、断路等特殊作业的申请、审查、许可、监护、验收等全过程实行信息化管理，应用视频监控设备对作业全过程进行实时监控和视频存储，还可应用智能视频监控系统对作业过程异常状态进行智能分析、监测报警，实现特殊作业全过程的规范化、程序化管理。特殊作业全过程信息化管理系统应实现作业计划预约申请、开具电子作业票证、过程安全控制、验收归档、统计分析等功能。参照《GB 30871-2014 化学品生产单位特殊作业安全规范》。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-5/1.png',
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'content',
                    list: [
                      '主要用于园区内企业特殊作业的报备、统计分析、线上抽查检查，有效防范化解特殊作业安全风险。',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业报备'
                  },
                  {
                    type: 'content',
                    list: ['实现园区企业特殊作业报备，报备数据包括作业编号、申请人、申请单位、作业类型、作业级别、作业开始时间、作业结束时间、状态、操作（查看作业票、查看审批）。']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-5/2.png',
                      '/images/product/pd-2-1-5/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业培训'
                  },
                  {
                    type: 'content',
                    list: ['园区下企业进行特殊作业培训，并进行考评，包括所属企业名称、姓名、培训类别、培训日期、培训内容、培训人员、考试成绩、培训结果等。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-5/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业人员'
                  },
                  {
                    type: 'content',
                    list: ['统计园区下各企业特殊作业人员进行管理，包括所属企业名称、特殊作业人员、作业类型、有效期、证书名称、证书编号、证书附件等。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-5/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业票证统计分析'
                  },
                  {
                    type: 'content',
                    list: ['实现与园区内企业电子作业许可系统的结构化数据对接，支持园区内特殊作业按不同企业、不同时间、不同作业类型等多维度进行统计分析，以及特殊作业信息在园区电子地图上实时显示和快速查询。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-5/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业在线抽查检查'
                  },
                  {
                    type: 'content',
                    list: ['实现在线抽查检查园区企业的特殊作业情况，支持与应急管理部特种作业操作证及安全生产知识和管理能力考核合格信息查询平台互通，以及企业现场摄像头、现场气体传感器等设备的联动调阅。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-5/7.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id: '2-1-6',
            name: '封闭化管理',
            menuIcon: '/images/menu/prod/icon-2-1-6.png',
            des: '全过程动态监测，确保区域安全风险有效隔离',
            icon: '/images/product/pd-2-1-6/3.png',
            content:'通过封闭化建设，规范和优化出入园区的人流、物流和车流行驶路径，全过程监管出入园区的人员、车辆、货物，防止外来输入风险，有效管控园区安全风险，提高园区事故预防和应急管理能力。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '通过封闭化建设，规范和优化出入园区的人流、物流和车流行驶路径，全过程监管出入园区的人员、车辆、货物，防止外来输入风险，有效管控园区安全风险，提高园区事故预防和应急管理能力。',
                    ]
                  }
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '门禁/卡口管理'
                  },
                  {
                    type: 'content',
                    list: ['按照客货分离、优化管理、规避风险、综合考虑停车场容量与园区安全容量的原则，根据园区实际情况分类设置综合、专用、普通、应急门禁/卡口，部署门禁/卡口管理系统，实现对人、车、物进出园管控，支持门禁/卡口视频监控、定位设备登记/发放/返还、自动放行、车道控制等。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '出入园管理'
                  },
                  {
                    type: 'content',
                    list: ['支持人员和车辆出入园申请、审核、长期/临时授权，支持危险化学品运输车辆预约、审核、授权，支持分区授权、异常行为报警和黑名单管理，支持人流、车流统计等。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-6/1.png',
                    ]
                  },
                  {
                    type: 'content',
                    list: ['对车辆进入园区时的基本信息情况进行录入，包括车辆类型、牵引车车牌号码、挂车车牌号码、车辆负责人、车辆品牌、联系电话等信息。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '危险化学品运输路径规划、定位和追踪'
                  },
                  {
                    type: 'content',
                    list: ['基于园区企业布局、道路及卡口分布、人流轨迹、运输物料、专用停车场等信息，在线规划危险化学品车辆园区内行驶路径、专用车道、通行时段等，并结合危险化学品车辆行驶分布信息，不断优化相关行驶路径规划。基于危险化学品运输车辆实时定位数据和园区重点区域电子围栏，掌握园区内危险化学品运输车辆的位置、行驶路线等实时动态，借助视频智能分析、测速和车辆定位数据，智能识别危险化学品运输车辆超速、违停、不按车道不按时段通行等不安全行为。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '人员和车辆分布管理'
                  },
                  {
                    type: 'content',
                    list: ['接入企业生产区域人员和车辆定位分布信息，结合卡口/门禁系统数据，准确显示园区人员分布动态，支持查询展示特定人员实时位置和历史轨迹；支持园区内人员分布异常情况的报警提示、统计分析、视频联动及可视化展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-6/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '危险化学品运输车辆停车场管理'
                  },
                  {
                    type: 'content',
                    list: ['参照《化工园区危险品运输车辆停车场建设标准》，在建设完善危险化学品停车场硬件设施的基础上，部署停车场管理系统，对接园区相关系统，实现运输车辆停放的规范化管理。支持准入清单设置、预约申请、分区管控、调度引导、统计分析等功能，支持联动视频、气体等感知设备。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-6/3.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id: '2-1-7',
            name: '敏捷应急',
            menuIcon: '/images/menu/prod/icon-2-1-7.png',
            des:'为事故应急提供技术支持，辅助园区进行快速、精准、科学应急响应',
            icon: '/images/product/pd-2-1-7/1.png',
            content:'主要用于园区安全生产应急预案管理、应急演练管理、应急资源管理、应急指挥调度、应急辅助决策、应急监测、应急值守，推动园区、企业落实日常应急管理及与各级政府间的应急联动，为事故应急提供技术支持，辅助园区进行快速、精准、科学应急响应。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '主要用于园区安全生产应急预案管理、应急演练管理、应急资源管理、应急指挥调度、应急辅助决策、应急监测、应急值守，推动园区、企业落实日常应急管理及与各级政府间的应急联动，为事故应急提供技术支持，辅助园区进行快速、精准、科学应急响应。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-7/1.png',
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '园区应急日常业务管理功能'
                  },
                  {
                    type: 'content',
                    list: ['信息接报是综合业务管理系统的核心功能。综合业务管理系统主要包括应急值守、数据统计分析和日常业务管理。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急预案管理'
                  },
                  {
                    type: 'content',
                    list: [
                      '实现园区企业应急预案的备案、维护等功能，支持应急预案查询、检索，多维度统计分析。实现园区应急预案的录入、评审、公布等流程管理，支持上级部门应急预案的录入查询。'
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急资源管理'
                  },
                  {
                    type: 'content',
                    list: [
                      '汇聚应急救援专家、队伍和物资数据，实现园区内应急资源的统一管理，支持应急资源信息的维护和快速查询，包括专家动态评估管理，队伍状态评估管理，物资有效性、完备性和可用性评估管理，以及应急物资按企业、按类别的统计分析和可视化展示。',
                      '主要包括应急组织、应急队伍、应急专家、应急通讯录、应急储备库、应急物资、应急装备、避难场所、救援医院、应急资源管理、知识库管理、案例管理和应急能力评估。'
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急指挥调度'
                  },
                  {
                    type: 'content',
                    list: [
                      '实现日常状态下的值班管理、应急车辆出动信息管理，应急状态下的接处警、上报续报、应急启动、资源调度、处置部署、应急终止等。支持调用人员定位信息数据和实时视频数据等辅助快速精准救援，以及通过应急广播、短信等方式通知园区内外相关人员进行应急处置或响应避险。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-7/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急辅助决策'
                  },
                  {
                    type: 'content',
                    list: [
                      '实现事故模拟分析、资源优化调配等。支持调用现场视频、实时气象信息、气体浓度、人员定位系统数据和灾害后果模拟分析结果（火灾、爆炸和泄漏模型，多米诺效应及次生衍生灾害），生成应急处置方案，为指挥人员提供决策支持。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-7/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急演练'
                  },
                  {
                    type: 'content',
                    list: [
                      '收录园区及企业的应急演练计划、演练记录及演练整改记录，并可对信息进行修改、分类、删除、导入导出等操作。',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急监测'
                  },
                  {
                    type: 'content',
                    list: [
                      '应急监测预警主要包括企业重大危险源的在线监测、应急告警监测等功能。',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '事故模拟'
                  },
                  {
                    type: 'content',
                    list: [
                      '平台在事故模拟方面，主要针对可燃液位泄露后燃烧所形成的池火灾、可燃液体高压泄露所形成的喷射火灾、可燃液体泄露形成蒸气云后点燃形成的火球火灾、由压力等物理变化引起的物理爆炸、由化学反应引导致化学变化而引起的化学爆炸、由于气体压缩压力过高引起的压缩气体物理爆炸、危险化学品泄露导致的中毒事故等。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-1-7/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '应急通讯管理'
                  },
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '应急通讯录',
                        content: '建立统一的应急人员库和应急机构库，对园区应急人员和应急就机构信息进行登记并整合园区各企业的应急人员信息。'
                      },
                      {
                        index: '（2）',
                        title: '应急通讯系统',
                        content: '实现在应急发生时，通过接口的形式快速拉起园区工作通的视频会议，实现对应急队伍与应急人员的统一指挥调度；通过园区工作通提供的对外接口，实现统一建群管理，将应急预案等信息通过对接接口的形式进行实时共享；通过园区工作通的视频接口，实现将应急场景下的现场画面，高空瞭望等视频画面进行视频共享。'
                      }
                    ]
                  },
                ]
              }
            ]
          }
        ]
      },
      {
        id: '2-2',
        name: '工业园区安全风险管控',
        list:[
          {
            id: '2-2-1',
            type: 2,
            name: '工业园区安全风险管控平台',
            menuIcon: '/images/menu/prod/icon-2-2-1.png',
            des:'基础设施数字化，运营管理精细化，功能服务信息化，产业发展智慧化',
            icon: '/images/product/pd-2-2-1/3.png',
            content:'智慧园区，指在各类产业园区、集聚区和经济技术开发区、功能区等区域内，按照科学的园区发展理念，运用云计算、物联网、大数据、人工智能、5G、区块链、数字孪生等新一代信息技术。在泛在信息全面感知和互联的基础上，全面整合园区内外的资源，实现人、物、园区功能系统之间无缝连接与协同联动的智能自感知、自适应、自优化，从而对生产、环保、公共安全、园区功能、民生、商务活动等多种园区需求做出智能的响应，形成具备可持续生命力的安全、便捷、高效、绿色的园区形态，使园区管理服务等更高效便捷，实现园区基础设施数字化，运营管理精细化、功能服务信息化和产业发展智慧化。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '智慧园区，指在各类产业园区、集聚区和经济技术开发区、功能区等区域内，按照科学的园区发展理念，运用云计算、物联网、大数据、人工智能、5G、区块链、数字孪生等新一代信息技术。在泛在信息全面感知和互联的基础上，全面整合园区内外的资源，实现人、物、园区功能系统之间无缝连接与协同联动的智能自感知、自适应、自优化，从而对生产、环保、公共安全、园区功能、民生、商务活动等多种园区需求做出智能的响应，形成具备可持续生命力的安全、便捷、高效、绿色的园区形态，使园区管理服务等更高效便捷，实现园区基础设施数字化，运营管理精细化、功能服务信息化和产业发展智慧化。',
                    ]
                  }
                ]
              },
              {
                title: '建设依据',
                haveBg: true,
                list: [
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '关于印发《内蒙古自治区智慧工业园区建设实施方案》的通知',
                        content: '通过工业园区云平台覆盖和智慧化应用建设，实现员工、企业、园区功能系统之间无缝衔接与协同联动的智能自感知、自适应、自优化，对企业生产、环保、安全、能耗、物流等关键数据及时采集、传输、存储、分析和智能响应，形成园区安全、便捷、高效、绿色的新型生态。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/1.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '《内蒙古自治区智慧工业园区建设指南》内工信园工字333号',
                        content: '以推动产业转型升级、提高经济增长效益为目标，以创新园区管理模式、服务产业发展为主线，结合园区内外资源要素及新一代信息技术，通过加快园区信息基础设施优化升级，促进园区产业智慧转型。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/2.png',
                    ]
                  },
                ]
              },
              {
                title: '总体结构',
                list: [
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        type: 'content',
                        model: 1,
                        list: ['为加快智慧工业园区建设进度，减少投资成本，避免重复和无序建设，按照“统一规划、统一标准、统一平台、统一管理”原则，软件建设方面，统建“经济运行监测”、“能耗监测”、“安全应急管理”，“环保监测”、“交通物流”等多个模块。']
                      },
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/3.png',
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '经济运行监测'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['园区企业按期通过经济运行指标填报系统进行经济运行数据填报，用以监测各园区工业规模、质量、效益等综合经济指标，以及投资、创新、集群、集约、开放发展等情况，对园区经济运行动态进行分析研判。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '能耗监测'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['可接入园区内使用电力、天然气、热力、自来水等能源，记录能源日、月、年消耗原始数据，根据用能流向优化园区用能需求，提高能源利用效率。']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/5.png',
                      '/images/product/pd-2-2-1/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '安全应急管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['安全生产重大危险源的安全包保责任落实监督、在线监测预警、重大风险管控、评价/评估报告管理及隐患管理和重大危险源企业分类监管。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/7.png',
                    ]
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['安全生产应急预案管理、应急演练管理、应急资源管理、应急指挥调度、应急辅助决策，推动园区、企业落实日常应急管理及与各级政府间的应急联动，为事故应急提供技术支持，辅助园区进行快速、精准、科学应急响应。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/8.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '交通物流管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['可接入园区门禁/卡口、周界防入侵、人员/车辆定位功能，准确显示园区人员分布动态情况（含实时位置和历史轨迹），园区人员/车辆的流量信息进行管控。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '环保监测'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['接入园区空气质量、水质、噪声、废气、土壤等实时环境监测设备，统计环保数据，对园区环保测评。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-2-1/10.png',
                    ]
                  },
                ]
              }
            ]
          },
        ]
      },
      {
        id: '2-3',
        name: '物联网平台',
        list:[
          {
            id: '2-3-1',
            name: '物联网平台',
            menuIcon: '/images/menu/prod/icon-2-3-1.png',
            des:'致力于为各类物联网场景和解决方案提供一致的基础平台',
            icon: '/images/product/pd-2-3-1/2.png',
            content:'Foslink适用于农业、工业、畜牧业、家居行业等需要设备联网上云的场景，致力于为各类物联网场景和解决方案提供一致的基础平台，包括物联网数据接收、数据存储，数据处理，以及数据应用接口等。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      'Foslink适用于农业、工业、畜牧业、家居行业等需要设备联网上云的场景，致力于为各类物联网场景和解决方案提供一致的基础平台，包括物联网数据接收、数据存储，数据处理，以及数据应用接口等。',
                      'Foslink平台可以便捷管理连接设备，具有简单易用，数据安全等优点。它向下通过可编程的适配器，可连接各种类型的设备和传感器；中间核心层可以对采集上来的各种数据进行路由、分类和存储；向上则提供了标准的数据开放接口和适配典型行业场景的开发套件，满足软件开发商方便、专注的进行行业应用开发的需求。'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/1.png',
                    ]
                  },
                ]
              },
              {
                title: '平台架构',
                haveBg: true,
                list: [
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/2.png',
                    ]
                  },
                ]
              },
              {
                title: '核心功能',
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '产品模型、编解码插件'
                  },
                  {
                    type: 'content',
                    list: ['Foslink开发平台将所有设备抽象成“产品模型”，用于描述设备具备的能力和特性。开发者通过定义“产品模型”，使平台理解该款设备支持的服务、属性、命令等信息。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/3.png',
                    ]
                  },
                  {
                    type: 'content',
                    list: [
                      'Foslink开发平台中编解码插件就是将设备上报的数据转为“产品模型”样式的数据。',
                      '以烟感为例，由于设备一般对省电要求较高，所以应用层数据一般不采用流行的JSON格式，而是采用二进制格式。但是，开发平台与应用侧使用JSON格式进行通信。因此您需要开发编码插件，供物联网平台调用，以完成二进制格式和JSON格式的转换。',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '边缘数据采集及分析'
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '组态分析'
                  },
                  {
                    type: 'content',
                    list: [
                      '自由排列，上传系统界面图片；提供组件库及元素，支持自主上传，让监控点更符合自身需求',
                      '多种维度数据统计与分析，让数据监控更直观',
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/6.png',
                    ]
                  },
                ]
              },
              {
                title: '平台优势',
                haveBg: true,
                list: [
                  
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-2-3-1/7.png',
                    ]
                  }
                ]
              }
            ]
          },
        ]
      }
    ]
  },
  {
    id: '3',
    name: '工业互联网+数字工厂',
    content: '工业互联网+数字工厂',
    icon: '/images/menu/menu-p-3.png',
    list: [
      {
        id:'3-1',
        name:'数字工厂',
        list: [
          // {
          //   id: '3-1-1',
          //   name: '标识解析平台',
          //   menuIcon: '/images/menu/prod/icon-3-1-1.png',
          //   des: '数字未来 万物标识 – 标识解析助力制造企业拥抱数字机遇',
          //   icon: '/images/product/pd-3-1-1/1.png',
          //   content:'依托于国家工业互联网中码院的MA码标识二级节点，专注研发一物一码系统集成平台。通过二维码做一物一码的防伪、防窜、溯源、工单、质保、使用说明书等产品管理及营销。通过机器及主要部件标识管理和产品追溯体系，形成产品来源可查、去向可追、责任可究的信息链条，成为覆盖生产制造、租赁管理、政府监管、行业协同的多级服务体系。',
          //   list: [
          //     {
          //       title: '平台概述',
          //       list: [
          //         {
          //           type: 'content',
          //           list: ['依托于国家工业互联网中码院的MA码标识二级节点，专注研发一物一码系统集成平台。通过二维码做一物一码的防伪、防窜、溯源、工单、质保、使用说明书等产品管理及营销。通过机器及主要部件标识管理和产品追溯体系，形成产品来源可查、去向可追、责任可究的信息链条，成为覆盖生产制造、租赁管理、政府监管、行业协同的多级服务体系。 ']
          //         }
          //       ]
          //     },
          //     {
          //       title: '平台特点',
          //       haveBg: true,
          //       list: [
          //         {
          //           type: 'order',
          //           model: 2,
          //           list:[
          //             {
          //               index: '（1）',
          //               title: '一码标识和共享协同',
          //               content: '无缝对接和同步国家标识解析平台，快速生成工业唯一标识，赋能产业上下游协同。'
          //             },
          //             {
          //               index: '（2）',
          //               title: '统一工业标准和服务',
          //               content: '对行业物品、设备、工艺等信息赋予规范的唯一标识，实现工业制造能力标准化与服务化。'
          //             },
          //             {
          //               index: '（3）',
          //               title: '互联互通和高效应用',
          //               content: '通过标识管理、标识解析、标识发现等标识服务实现企业内部不同信息系统之间、不同企业之间、不同环节之间信息的有效共享，促进全产业链环节互联共通。'
          //             }
          //           ]
          //         }
          //       ]
          //     },
          //     {
          //       title: '核心功能',
          //       list: [
          //         {
          //           type: 'order',
          //           model: 1,
          //           list:[
          //             {
          //               index: '（1）',
          //               title: '标识管理：',
          //               content: '对企业节点信息进行管理，将标识注册、解析数据进行可视化展示，进行标识的发码，读写，解析，认证，查询等操作，统一入口管理标识内容，全流程管理标识生命周期。'
          //             },
          //             {
          //               index: '（2）',
          //               title: '流程溯源：',
          //               content: '以产品全生命周期为核心，通过统一工业互联网标识，将产品从原材料（配件）采购、生产、库存、销售和客服等环节串联起来，同时与生产经营系统、订单管理系统、仓储物流系统等进行数据打通，完整的呈现产品全生命周期视图。'
          //             },
          //             {
          //               index: '（3）',
          //               title: '无缝对接：',
          //               content: '标识解析系统与工业互联网各平台深度融合，让应用平台-物联网平台--大数据-AI平台无缝对接标识解析系统，实现一物一码，扫码解析。一码到底，协同制造，一码多识，分权管控。如通过唯一标识码实现网关设备静态数据与实时动态数据全流程共享，提升行业数据共享协同水平。'
          //             }
          //           ]
          //         }
          //       ]
          //     },
          //     {
          //       title: '应用场景',
          //       haveBg: true,
          //       list: [
          //         {
          //           type: 'order',
          //           model: 2,
          //           list:[
          //             {
          //               index: '（1）',
          //               title: '供应链管理',
          //               content: '基于标识解析去完善朗坤现有的供应链管理系统。在供应商管理环节，通过标识将所有的供应商、产品与企业的需求进行关联，不断补充、完善企业的供应链，避免供应链断掉。在质量管理环节将产品的使用情况、相关数据与供货商/产品关联、分析，淘汰劣质供应商，优化企业供应链。'
          //             },
          //             {
          //               index: '（2）',
          //               title: '生产制造应用',
          //               content: '帮助制造企业实现企业内部从设备、控制系统及信息系统的互联和互通。协助企业内部各层级信息系统的集成整合，实现生产、供应链、产品等数据的无缝传输，构建数据优化闭环。'
          //             },
          //             {
          //               index: '（3）',
          //               title: '能源电力',
          //               content: '行业普遍存在工业互联网技术标准不统一、边端设备智能采集及工业数据分析效率低等问题。整个电力行业缺乏标准化体系建设，尚未形成行业内生产对象的统一描述，严重制约产业链上下游协作互通，也降低整个产业在产品设计、制造生产、服务化方面转型升级的速度。'
          //             },
          //             {
          //               index: '（4）',
          //               title: '食品加工',
          //               content: '打通农畜产品全产业链各个节点信息孤岛为基础，以构建符合国家工业互联网标识解析体系技术要求的数据管理平台为总体设计，实现数据交换标准和基础数据的统一编码，确保全产业链中的各节点数据无缝对接。'
          //             }
          //           ]
          //         }
          //       ]
          //     },
          //   ]
          // },
          {
            id: '3-1-2',
            name: '企业安全管理系统',
            menuIcon: '/images/menu/prod/icon-3-1-2.png',
            des:'一种新型企业安全管理工具，应对最具挑战的安全管理难题',
            icon: '/images/product/pd-3-1-2/4.png',
            content:'企业安全管理系统强化企业快速感知、实时监测、超前预警、动态优化、智能决策、联动处置、系统评估、全局协同能力，打造企业工业互联网新基础设施，建设企业与园区节点对接，全面提升企业安全生产管理水平。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '企业安全管理系统强化企业快速感知、实时监测、超前预警、动态优化、智能决策、联动处置、系统评估、全局协同能力，打造企业工业互联网新基础设施，建设企业与园区节点对接，全面提升企业安全生产管理水平。',
                      '企业安全管理系统主要涵盖了系统概况、双重管控、重点部位安全监测、人员在岗在位、生产全要素等模块，为企业生产管理人员提供一站式的企业安全生产信息汇集、操作、待办、数据监测、报警查看操作平台，系统为不同角色提供了不同功能和数据权限，便于企业的管理和生产。'
                    ]
                  }
                ]
              },
              {
                title: '建设依据',
                haveBg: true,
                list: [
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（1）',
                        title: '《安全生产三年行动专项行动计划》安委（2020）3号',
                        content: '“督促企业加大安全投入，用足用好企业安全生产费用提取使用、支持安全技术设备设施改造等有关财税政策，重点用于风险防控和隐患排查治理，推进各重点行业领域机械化、信息化、智能化建设”'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/1.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（2）',
                        title: '关于印发《“工业互联网+安全生产”行动计划（2021-2023年）》的通知工信部联信发〔2020〕157号',
                        content: '“工业互联网+安全生产”是通过工业互联网在安全生产中的融合应用，增强工业安全生产的感知、监测、预警、处置和评估能力，加速安全生产从静态分析向动态感知、事后应急向事前预防、单点防控向全局联防的转变，提升工业生产本质安全水平。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/2.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 2,
                    list:[
                      {
                        index: '（3）',
                        title: '《中华人民共和国安全生产法》（国家主席令[2002]第70号，国家主席令[2021]第88 号修正）',
                        content: '“第四条生产经营单位必须遵守本法和其他有关安全生产的法律、法规，加强安全生产管理，建立健全全员安全生产责任制和安全生产规章制度，加大对安全生产资金、物资、技术、 人员的投入保障力度，改善安全生产条件，加强安全生产标准化、信息化建设，构建安全风险分级管控和隐患排查治理双重预防机制，健全风险防范化解机制，提高安全生产水平，确保安全生产”'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/3.png',
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '重点部位安全监测'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['是在对涉及重点部位识别，重点部位监管，重点部位包保责任，利用物联网、信息化等技术手段实现重要安全参数（温度、压力、液位、可燃气体浓度、有毒气体浓度、视频等）的在线监测预警，对重点部位进行包保责任确认，提升对重点部位的动态监管能力，而且能够及时发现重点部位关键装置事故风险隐患，提醒企业及时进行应急处置，降低事故发生率。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '双重预防机制'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['包括动态监控风险管控措施落实隐患排查任务推送、隐患排查治理情况跟踪监督、机制运行效果评估、异常状态自动预警及考核奖惩、隐患排查任务和预警信息接收、现场隐患排查情况实时上报、隐患治理全程跟踪等功能。对生产过程危险与有害因素进行辨识，运用定性或定量的统计分析方法确定其风险程度，使用四色图进行标绘，形成两单三卡。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '特殊作业'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['将动火、受限空间、盲板抽堵、高处、吊装、临时用电、动土、断路特殊作业审批许可条件条目化、电子化、流程化。通过信息化手段对作业全程进行过程和痕迹管理，从而实现特殊作业申请、审查、许可、监护、验收全流程信息化、规范化、程序化管理。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '人员在岗在位'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['用于管理企业作业人员定时、定人、定岗履职的物联网信息系统，可通过生物识别、智能门禁、实时定位等技术，有效识别、跟踪作业人员及车辆的位置和行为。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/7.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '智能视频监控'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['50+成熟算法，适配安全生产、建筑楼宇、人车管理、社区管理等多种场景。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/8.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '智慧消防管控'
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（1）',
                        title: '综合展示分析：',
                        content: '查看实时监测、今日火警、设备离在线、待复核报警情况、报警变化趋势；消防控制室值班、接入单位基本信息'
                      },
                      {
                        index: '（2）',
                        title: '实时监测一张图：',
                        content: '展示场所位置、实时数据分析信息；支持三色预警，红色、黄色、绿色分别代表着该场所有火警、隐患和正常。'
                      },
                      {
                        index: '（3）',
                        title: '多维度多渠道推送：',
                        content: '报警联动支持短信、语音通知、手机APP告警，将报警信息通过短信等、语言、手机APP方式发送给指定人员。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '有毒有害气体监测'
                  },
                  {
                    type: 'content',
                    list: [
                      '通过在工程师站或系统网络上加装物联网网关，获取DCS上仪表的采集信息',
                      '经过加装气体检测仪，实时监测企业环境中的可燃有毒有害气体浓度信息'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/10.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '用电安全管控'
                  },
                  {
                    type: 'content',
                    list: [
                      '通过物联网传感终端，将人员密集场所的电气安全数据，实时传输至安全用电管理服务器实时采集火灾隐患数据，包括温度、剩余电流、电流等及时告警提醒，秒级上传数据并实时弹出异常通知'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/11.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '安全教育培训'
                  },
                  {
                    type: 'content',
                    list: [
                      '以信息化手段，助力企业安全教育培训，促进企业安全生产管理措施的持续改进'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-2/12.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id: '3-1-3',
            name: '设备智能维保平台',
            path: '/maintenance',
            menuIcon: '/images/menu/prod/icon-3-1-3.png',
            des: '实现生产设备全生命周期精细化管理，提升设备综合效率',
            icon: '/images/product/pd-3-1-3/6.png',
            content:'设备运维管理平台是基于物联网、大数据、人工智能技术打造的设备管理平台。提供面向设备智能化售后服务及运维的全生命周期综合管理，围绕设备联网监控，维修保养，巡检点检，数据采集与分析等核心常见实现运维数字化。通过主动预防系统机制减少设备异常停机带来的产能损失，降低设备故障发生频率。',
          },
          {
            id: '3-1-4',
            name: '环境监控系统',
            menuIcon: '/images/menu/prod/icon-3-1-4.png',
            des:'全方位监控环境数据，不间断的数据跟踪、统计分析和安全监管',
            icon: '/images/product/pd-3-1-4/2.png',
            content:'该系统是基于移动互联网、云计算技术，通过物联网传感终端，将办公建筑、学校、医院、工厂、体育场馆、宾馆、福利院等人员密集场所的动力设备运行数据、电气安全数据、环境安全数据，实时传输至管理服务器，为用户提供不间断的数据跟踪、统计分析和安全监管。平台将发现的各种安全隐患信息及时告警提醒，并推送给相关人员，以便及早发现和消除隐患，真正做到防患于未然。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['该系统是基于移动互联网、云计算技术，通过物联网传感终端，将办公建筑、学校、医院、工厂、体育场馆、宾馆、福利院等人员密集场所的动力设备运行数据、电气安全数据、环境安全数据，实时传输至管理服务器，为用户提供不间断的数据跟踪、统计分析和安全监管。平台将发现的各种安全隐患信息及时告警提醒，并推送给相关人员，以便及早发现和消除隐患，真正做到防患于未然。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/1.png',
                    ]
                  },
                  {
                    type: 'content',
                    list: ['系统采用分层分布式网络结构，具有良好的可靠性与实时性，主要由现场感知层（计量终端）、网络层（通讯管理终端）和平台层（监控平台）三个部分组成。']
                  },
                  {
                    type: 'order',
                    model: 4, // 4无序号, 是点
                    list:[
                      {
                        index: '（1）',
                        title: '感知层：',
                        content: '连接于网络中的各类传感器，包括本公司各系列带通讯网络的电力仪表、温湿度控制器、开关量监测模块以及合格供应商的水表、气表、冷热量表等。'
                      },
                      {
                        index: '（2）',
                        title: '网络层：',
                        content: '智能网关，采集感知层的数据，进行规约转换及存储之后将数据上传至管理平台。'
                      },
                      {
                        index: '（3）',
                        title: '平台层：',
                        content: '包含应用服务器和数据服务器，可在PC端或移动端实现应用。'
                      }
                    ]
                  },
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '可视化展示'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['展示当前项目今日统计概况，包括接入企业数、网关、设备、今日报警、未处理报警、设备状态、设备分类、报警分类、近7日报警统计、今日预警/故障、报警列表等相关统计信息的展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '网关及从机配置'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['配置企业网关和数采箱，根据需要添加各个区域的从机，进行温度、压力、电流、功率、故障电弧、温湿度等数据的采集，设置采集上下限值，并将超过限值的采集器进行报警，实时获取企业的监控数据。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '数据监测—实时监控'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['24小时监视各探测点信息。可查看设备的状态、实时数据、历史数据、巡检记录和报警信息；对项目接入的探测器信息，展示设备的状态、网关识别号、设备型号、物联网卡号、区域位置等详细信息，点击列表可以查看到实时数据展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '能耗分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['可查看各回路的用能分析，包括日报、周报、月报、季报和年报。支持能耗同比，环比分析。支持统计自定义时间段的用能情况及导出。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '电能质量'
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（1）',
                        title: '谐波监测：',
                        content: '谐波监测一般以监测仪表为核心，通过有线（RS232/485）和网络（RJ45）将监测数据采集后进行分析处理，以图表方式输出，供相关技术人员分析和利用。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/6.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（2）',
                        title: '三相不平衡：',
                        content: '三相不平衡是由于三相负载不平衡以及系统元件三相参数不对称所致。三相电压平衡的状况是电能质量的主要指标之一。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/7.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（3）',
                        title: '稳态监测：',
                        content: '稳态监测是一种基于相异度计算的电能质量稳态监测方法，在由电能监测终端和模型库构成的系统中，电能监测终端的输入端与电网监测点连接、通讯端连接所述模型库，经过相异度计算进行聚类和分类，以达到电能质量故障的精确诊断、分析，随着电能质量数据的丰富、模型库的事件模型增加完善，模型库自动分析的结果将会更加准确，快速。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/8.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '需量监测'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['支持查看和导出各月最大需量及发生时间，支持查看历史需量。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '报告分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['用户报告是针对项目一个周期内的用电数据进行汇总，生成安全用电分析报告。以年、月、日对工厂的能源利用情况、线路损耗情况、设备运行情况、运维情况等进行全面的统计分析，让用户全面了解系统的运行情况，并为用户提供数据基础，方便用户发现设备异常，从而找出改善点，以及针对用能情况挖掘节能潜力。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-4/10.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id: '3-1-5',
            name: '能耗管理系统',
            menuIcon: '/images/menu/prod/icon-3-1-5.png',
            des:'升级能源管理范式，深度释放能源价值，助力企业实现双碳目标',
            icon: '/images/product/pd-3-1-5/1.png',
            content:'企业能耗监管平台采用自动化、信息化和集中管理模式，对企业的生产、输配和消耗环节实行集中扁平化的动态监控和数据化管理，监测企业电、水、燃气、煤、油等各类能源的消耗情况，通过数据分析、挖掘和趋势分析，帮助企业针对各种能源需求及用能情况、产品能源单耗、各工序能耗、重大能耗设备的能源利用情况进行数据采集、设备管理、能源采集、能源监测、能耗分析、告警管理、统计分析、可视化展示等，为企业加强能源管理，提高能源利用效率、挖掘节能潜力、节能评估提供基础数据和支持。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: [
                      '企业能耗监管平台采用自动化、信息化和集中管理模式，对企业的生产、输配和消耗环节实行集中扁平化的动态监控和数据化管理，监测企业电、水、燃气、煤、油等各类能源的消耗情况，通过数据分析、挖掘和趋势分析，帮助企业针对各种能源需求及用能情况、产品能源单耗、各工序能耗、重大能耗设备的能源利用情况进行数据采集、设备管理、能源采集、能源监测、能耗分析、告警管理、统计分析、可视化展示等，为企业加强能源管理，提高能源利用效率、挖掘节能潜力、节能评估提供基础数据和支持。'
                    ]
                  }
                ]
              },
              {
                title: '平台特点',
                haveBg: true,
                list: [
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '1、',
                        title: '',
                        content: '强化能耗主动监控，实现能源集中管理：将企业的水、电、气、热等能源进行集中监控，自定义能源使用计划，构建统一集成的能源管理平台，能够主动、及时的发现能源问题，提高能源管理水平。'
                      },
                      {
                        index: '2、',
                        title: '',
                        content: '细化能源管控分类，摸清能耗分类条目：可以按照工艺流程、区域场所、能源类型、产品分类、设备类型等多种分类维度查看能源消耗的情况，帮助企业管理者细化能源管控条目，有针对性地进行落后生产工艺改革。'
                      },
                      {
                        index: '3、',
                        title: '',
                        content: '能耗数据可视化展示，多维度统计分析对比：对于超计划的能耗告警情况，企业用能情况，碳排情况的趋势分析和同环比分析，结合专家判断，为企业能源管控给出改造和运行建议。'
                      }
                    ]
                  },
                ]
              },
              {
                title: '核心功能',
                list: [
                  {
                    type: 'content',
                    model: 1,
                    list: ['企业能耗监管平台以科学、规范的统计指标体系为基础，利用信息技术、通讯技术物联网技术以及云技术，以数据的获取和整合为核心，通过规范数据标准和数据交换平台的建立，基于3D建模技术，全景式呈现企业能耗监管平台，实现能源管理的自动化、数字化、智能化。']
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '1、',
                        title: '',
                        content: '实现能源数据自动采集、异常报警、能耗自动对标、能源报表生成等自动化；'
                      },
                      {
                        index: '2、',
                        title: '',
                        content: '通过全方位实时监控与智能报警，及时处理能耗异常、排放异常等情况，帮助企业实现节能减排、改善环境质量；'
                      },
                      {
                        index: '3、',
                        title: '',
                        content: '基于企业生产能耗模型，实现能源数据的深度挖掘及分析，提高企业快速决策能力。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-5/1.png',
                      '/images/product/pd-3-1-5/2.png',
                      '/images/product/pd-3-1-5/3.png',
                    ]
                  },
                ]
              }
            ]
          },
          // {
          //   id: '3-1-6',
          //   name: '订单管控系统',
          //   list: []
          // },
          {
            id: '3-1-7',
            name: '数字孪生三维可视化平台',
            type: 3,
            menuIcon: '/images/menu/prod/icon-3-1-1.png',
            icon: '/images/product/pd-3-1-7/2.png',
            des:'实现各个系统的信息交互、信息共享、联动互动，独立共生',
            content:'数字孪生利用了地理信息云平台，综合运用云计算、物联网、自动化控制、现代通讯、虚拟现实、图像识别、软硬件集成等技术，借助地理信息技术、三维虚拟化等高科技手段，建设了集地上地下、室内室外一体化的三维地理信息平台。定制研发了智慧园区可视化、数字工厂三维可视化、智慧节能可视化、智慧城市可视化、智慧景区可视化、智慧消防可视化、智慧仿真培训演练可视化等，实现各个系统的信息交互、信息共享、参数关联、联动互动，独立共生，数字孪生平台提供全方位智能服务。',
            list: [
              {
                title: '平台特点',
                list: [
                  {
                    type: 'content',
                    list: [
                      '随着物联网信息技术与三维可视化的快速健康发展，为用户提供了优越的管理服务能效和视觉体验。基于专业的3D引擎渲染开发，实现全面智能联动与融合，综合运用多种现代信息技术，实现一体化集成管理和系统联动。',
                      '数字孪生利用了地理信息云平台，综合运用云计算、物联网、自动化控制、现代通讯、虚拟现实、图像识别、软硬件集成等技术，借助地理信息技术、三维虚拟化等高科技手段，建设了集地上地下、室内室外一体化的三维地理信息平台。定制研发了智慧园区可视化、数字工厂三维可视化、智慧节能可视化、智慧城市可视化、智慧景区可视化、智慧消防可视化、智慧仿真培训演练可视化等，实现各个系统的信息交互、信息共享、参数关联、联动互动，独立共生，数字孪生平台提供全方位智能服务。'
                    ]
                  }
                ]
              },
              {
                title: '系统架构',
                haveBg: true,
                list: [
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-7/1.png',
                    ]
                  },
                ]
              },
              {
                title: '行业应用',
                list: [
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-7/2.png',
                    ]
                  },
                ]
              },
              {
                title: '成功案例',
                haveBg: true,
                list: [
                  {
                    type: 'card-row',
                    model: 'card',
                    gutter: 40,
                    colSpan: 12,
                    list: [
                      {
                        model: 2,
                        img: '/images/product/pd-3-1-7/3.png',
                        title: ['制造业的数字工厂'],
                        path: 'productDetails',
                        pathId: '',
                        content: []
                      },
                      {
                        model: 2,
                        img: '/images/product/pd-3-1-7/4.png',
                        title: ['数字孪生化工园区'],
                        path: 'productDetails',
                        pathId: '',
                        content: []
                      },
                    ]
                  },
                ]
              },
            ]
          },
          {
            id: '3-1-8',
            name: '生产计划管理系统',
            des:'',
            icon: '/images/product/pd-3-1-8/5.png',
            content:'深入调研工厂生产排产、产品工艺管理、任务下达、数据统计等业务流程，将业务和数据信息化、数字化、透明化，集成人员审核监管，全方位掌握生产计划到落地的总过程，监督生产日报生产数据的准确性，方便工厂实现高效的运营过程透明化，加速数据驱动的业务迭代。',
            list: [
              {
                title: '平台概述',
                list: [
                  {
                    type: 'content',
                    list: ['深入调研工厂生产排产、产品工艺管理、任务下达、数据统计等业务流程，将业务和数据信息化、数字化、透明化，集成人员审核监管，全方位掌握生产计划到落地的总过程，监督生产日报生产数据的准确性，方便工厂实现高效的运营过程透明化，加速数据驱动的业务迭代。 ']
                  }
                ]
              },
              {
                title: '平台功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '产品工艺管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['提供产品工艺的全流程维护功能，支持产品工艺的新建、编辑、删除、查看的操作，维护产品的名称、标准定额、定额折扣等内容，为生产计划的制定提供基础元数据。']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-8/5.png',
                      '/images/product/pd-3-1-8/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '生产计划业务流程'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['为各个工厂制定生产计划制定，审核，会签，执行等业务流程，支持业务流程的定制和生产任务的下发。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 18,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-8/7.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '生产计划管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['为生产计划员提供便利的生产计划定制工具，支持多产品选择，生产任务数量制定，进度排产，换线提醒，阶段提醒等操作。']
                  },
                  {
                    type: 'img',
                    imgType: 2,
                    colSpan: 12,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-8/8.png',
                      '/images/product/pd-3-1-8/9.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '生产任务执行'
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-3-1-8/10.png',
                    ]
                  },
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: '4',
    name: '厂区消防监管',
    content: '数字消防管理',
    icon: '/images/menu/menu-p-4.png',
    list: [
      {
        id:'4-1',
        name: '厂区消防监管',
        list: [
          {
            id:'4-1-1',
            name: '用电安全平台',
            menuIcon: '/images/menu/prod/icon-4-1-1.png',
            des:'针对电气火灾事故频发而研发的一套电气火灾预警和预防管理系统',
            icon: '/images/product/pd-4-1-1/6.png',
            content:'用电安全监管系统是未来工厂实现绿色低碳生产的必要辅助工具。利用物联网、云计算、大数据等先进技术实时探测电气线路和用电设备安全隐患，通过智能化的数据统计和分析，进行科学节能的用电管理。“用电安全监管系统” 与“企业能耗监管平台”、“化工园区安全监管平台”，“化工企业安全监管平台”，三个平台形成一个致力于保障工业企业以及其所在产业园区的用电安全、生产安全、风险防控、应急处置、智能调控、能源监管、降本增效的产品体系。',
            list: [
              {
                title: '解决方案定位',
                list: [
                  {
                    type: 'content',
                    model: 3, //3段落间隔加大
                    list: [
                      '用电安全监管系统是未来工厂实现绿色低碳生产的必要辅助工具。利用物联网、云计算、大数据等先进技术实时探测电气线路和用电设备安全隐患，通过智能化的数据统计和分析，进行科学节能的用电管理。“用电安全监管系统” 与“企业能耗监管平台”、“化工园区安全监管平台”，“化工企业安全监管平台”，三个平台形成一个致力于保障工业企业以及其所在产业园区的用电安全、生产安全、风险防控、应急处置、智能调控、能源监管、降本增效的产品体系。',
                      '根据《工业企业能源管控中心建设指南》指导要求，建设工业企业能耗监管平台最终目的是实现统一监管、分散管控，同时实现节能减排降耗，而节能减排降耗工作不仅是节能产品的应用及系统的控制，更是一个基于动态能源平衡、数据支撑、数字决策、集成产品和控制的系统化工程，主要功能包括可视化投屏、数据监测、电能质量、能耗分析、需量分析、隐患管理、报告分析、运维管理等，以能源管理体系为牵引，能管平台为抓手，逐步开展能源管控工作。'
                    ]
                  }
                ]
              },
              {
                title: '平台特点',
                haveBg:true,
                list: [
                  {
                    type: 'card-row',
                    model: 'card',
                    gutter: 40,
                    colSpan: 8, //3段落间隔加大
                    list: [
                      {
                        img: '/images/product/pd-4-1-1/1.png',
                        title: ['实时监测隐患数据','火灾隐患无所遁形'],
                        content: ['实时采集火灾隐患数据，包括温度、剩余电流、电流等，秒级上传数据并实时弹出异常通知。']
                      },
                      {
                        img: '/images/product/pd-4-1-1/2.png',
                        title: ['实时处理分析数据','多种方式通知到人'],
                        content: ['实时处理分析数据，及时告警，并通过短信、电话等方式推送，并可根据现场状况不同，灵活修改电流、漏电阈值，预警判断更准确。']
                      },
                      {
                        img: '/images/product/pd-4-1-1/3.png',
                        title: ['设备数据可视化展示','报表分析及专家建议'],
                        content: ['可查看所有设备数据的运行趋势，包括日曲线和月曲线，可以辅助发现设备运行的安全隐患，结合专家判断，给出改造和运行建议。']
                      }
                    ]
                  }
                ]
              },
              {
                title: '平台特点',
                list: [
                  {
                    type: 'left-right',
                    gutter: 40,
                    list: [
                      {
                        colSpan: 12,
                        list: [
                          {
                            type: 'content',
                            model: 1,
                            list: [
                              '系统采用分层分布式网络结构，具有良好的可靠性与实时性，主要由现场感知层（计量终端）、网络层（通讯管理终端）和平台层（监控平台）三个部分组成。',
                            ]
                          },
                          {
                            type: 'order',
                            model: 4,
                            list:[
                              {
                                index: '',
                                title: '感知层：',
                                content: '连接于网络中的各类传感器，包括本公司各系列带通讯网络的电力仪表、温湿度控制器、开关量监测模块以及合格供应商的水表、气表、冷热量表等。'
                              },
                              {
                                index: '',
                                title: '网络层：',
                                content: '智能网关，采集感知层的数据，进行规约转换及存储之后将数据上传至管理平台。'
                              },
                              {
                                index: '',
                                title: '平台层：',
                                content: '包含应用服务器和数据服务器，可在PC端或移动端实现应用，主要平台功能包括：可视化投屏、数据监测、电能质量、能耗分析、需量分析、隐患管理、报告分析、运维管理。'
                              }
                            ]
                          }
                        ]
                      },
                      {
                        colSpan: 12,
                        list: [
                          {
                            type: 'img',
                            imgType: 1,
                            colSpan: 24,
                            gutter: 0,
                            list: [
                              '/images/product/pd-4-1-1/4.png',
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                title: '主要功能',
                haveBg: true,
                list: [
                  {
                    type: 'headline',
                    icon:'',
                    content: '可视化投屏'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['展示当前项目今日统计概况，包括接入企业数、网关、设备、今日报警、未处理报警、设备状态、设备分类、报警分类、近7日报警统计、今日预警/故障、报警列表等相关统计信息的展示。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '数据实时监测'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['实现线路的各类实时信息（电量、剩余电流、温度、过载电流、电压、故障电弧）的在线监测告警、自动采集以及云端同步。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '能耗分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['可查看各回路的用能分析，包括日报、周报、月报、季报和年报。支持能耗同比，环比分析。支持统计自定义时间段的用能情况及导出。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/7.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '电能质量'
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（1）',
                        title: '谐波监测：',
                        content: '谐波监测一般以监测仪表为核心，通过有线（RS232/485）和网络（RJ45）将监测数据采集后进行分析处理，以图表方式输出，供相关技术人员分析和利用。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/8.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（2）',
                        title: '三相不平衡：',
                        content: '三相不平衡是由于三相负载不平衡以及系统元件三相参数不对称所致。三相电压平衡的状况是电能质量的主要指标之一。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/9.png',
                    ]
                  },
                  {
                    type: 'order',
                    model: 1,
                    list:[
                      {
                        index: '（3）',
                        title: '稳态监测：',
                        content: '稳态监测是一种基于相异度计算的电能质量稳态监测方法，在由电能监测终端和模型库构成的系统中，电能监测终端的输入端与电网监测点连接、通讯端连接所述模型库，经过相异度计算进行聚类和分类，以达到电能质量故障的精确诊断、分析，随着电能质量数据的丰富、模型库的事件模型增加完善，模型库自动分析的结果将会更加准确，快速。'
                      }
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/10.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '需量分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['支持查看和导出各月最大需量及发生时间，支持查看历史需量。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/11.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '隐患管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['隐患管理是对设备发生的隐患事项全流程闭环管理的功能，包括隐患巡查、处理和记录，并实时统计隐患数量、隐患发生趋势、隐患分类和隐患排名，支持按照创建时间、项目名称、所在区域等条件来对隐患记录信息进行针对性的查询操作。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/12.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '运维管理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['支持制定巡检计划和巡检日历，查看相应的巡检记录和轨迹，并对巡检进行评分。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-1/13.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '报告分析—用户报告'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['用户报告是针对项目一个周期内的用电数据进行汇总，生成安全用电分析报告。以年、月、日对工厂的能源利用情况、线路损耗情况、设备运行情况、运维情况等进行全面的统计分析，让用户全面了解系统的运行情况，并为用户提供数据基础，方便用户发现设备异常，从而找出改善点，以及针对用能情况挖掘节能潜力。']
                  },
                  {
                    type: 'left-right',
                    gutter: 40,
                    list: [
                      {
                        colSpan: 16,
                        list: [
                          {
                            type: 'img',
                            imgType: 4,
                            colSpan: 24,
                            gutter: 0,
                            list: [
                              '/images/product/pd-4-1-1/14.png',
                            ]
                          }
                        ]
                      },
                      {
                        colSpan: 8,
                        list: [
                          {
                            type: 'img',
                            imgType: 4,
                            colSpan: 24,
                            gutter: 0,
                            list: [
                              '/images/product/pd-4-1-1/15.png',
                            ]
                          }
                        ]
                      }
                    ]
                  },
                ]
              }
            ]
          },
          {
            id:'4-1-2',
            name: '火灾隐患防控平台',
            menuIcon: '/images/menu/prod/icon-4-1-2.png',
            des:'数字化平台在消防领域的高度集成和综合应用',
            icon: '/images/product/pd-4-1-2/1.png',
            content:'随着消防报警技术和消防物联网技术的飞速发展，促进智慧安全预警网络逐步由消防信息化转向数字化、智能化方向发展。',
            list: [
              {
                title: '背景概述',
                list: [
                  {
                    type: 'content',
                    model: 3, //3段落间隔加大
                    list: [
                      '随着消防报警技术和消防物联网技术的飞速发展，促进智慧安全预警网络逐步由消防信息化转向数字化、智能化方向发展。',
                      '火灾隐患防控系统以“感、传、知、用”等物联网技术、云计算、云存储进行数据计算、分析、存储、交换和管理，实现数字化平台在消防领域的高度集成和综合应用。可接入多种类型智能设备，可跨网络进行多层级管理将安全隐患扼杀在萌芽状态，减少生命财产损失、营造社会安全稳定的大环境，为建设智慧城市公共安全服务。'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/1.png',
                    ]
                  }
                ]
              },
              {
                title: '适用场景',
                haveBg:true,
                list: [
                  {
                    type: 'content',
                    model: 1, //3段落间隔加大
                    list: [
                      '火灾隐患防控系统覆盖范围广泛、涉及领域众多，适用于九小场所、住宅区、校园、医院、工地、商业综合体、物流储运、基础设施、用电安全等人员密集、消防重点保护单位。'
                    ]
                  },
                ]
              },
              {
                title: '功能点',
                list: [
                  {
                    type: 'card-row',
                    model: 'circle',
                    gutter: 30,
                    colSpan: 8,
                    list: [
                      {
                        title: '',
                        img: '/images/product/pd-4-1-2/icon-14-1.png',
                        content: [
                          '实时监控、智能分析',
                          '实时监测警情预警'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-2/icon-14-2.png',
                        content: [
                          '预警联动、警情处置',
                          '提升预警处置能力'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-2/icon-14-3.png',
                        content: [
                          '监控管理、信息推送',
                          '强化风险防控能力'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-2/icon-14-4.png',
                        content: [
                          '巡查治理、隐患管理',
                          '落实风险安全责任'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-2/icon-14-5.png',
                        content: [
                          '数据分析、可视管理',
                          '提高决策能力'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-2/icon-14-6.png',
                        content: [
                          '实时监测、设备管理',
                          '呈现设备状态及报警趋势'
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                title: '实施效果',
                haveBg: true,
                list: [
                  {
                    type: 'content',
                    model: 1,
                    list: ['运用物联网、移动互联网、大数据、云计算技术，实时监控消防设备/设施运行状态，实现火灾险情的早发现、早预警、早处理，全方位提高消防安全管理能力。主要功能有警情监控、视频监控、设备管理、隐患跟踪、巡查治理、统计分析、可视化信息。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '警情监控'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['当发生预警事件时，平台能接收预警推送提示，警情监控界面显示报警位置和时间、报警内容、复核流程、监控记录、设备信息等，并将预警信息通过电话、短信采取分级推送方式通知负责人，通过复核操作对预警信息上传图片、视频、语音相关信息，可对设备进行消音和复位远程控制。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '隐患跟踪'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['通过监督上报、巡查上报、社会上报多种方式上传图片、视频、语音相关信息发现隐患，使用移动端进行隐患分配、整改、跟踪、督促，整改内容可上传图片、视频、语音信息。一键督促巡查负责人，落实重大安全隐患排查、隐患治理。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '巡查治理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['针对巡查任务，可准确锁定巡查人员、相关设备、任务时间，进行巡查信息上报、结果受理、任务分配、任务整改、处置反馈、结果验收全流程的闭环处理。管理人员随时可调取巡查轨迹、人员位置。做到巡查管理的统筹化、信息化、智能化。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '设备监管'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['可接入多种类型智能设备，可跨网络进行多层级管理，对单位的消防设备进行全程监控，通过平台可随时查看设备状态、预警设备、位置信息、数据流、设备所属系统、设备详细地址、信息统计等信息。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '视频监控'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['对所监控区域实时监控，可采集区域入侵、人员离岗、通道堵塞等消防安全隐患事件，可自主规划监控区域及设置采集间隔时间等。预警设备关联摄像头后，在其预警信息中可实时监控视频信息。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '统计分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['全方位针对设备类型、设备状态、隐患状态、报警趋势等数据进行实时统计、信息反馈，将数据通过图文形式进行汇总呈现，并定期生成统计报表以作参考分析。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-2/7.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id:'4-1-3',
            name: '消防监管平台',
            menuIcon: '/images/menu/prod/icon-4-1-3.png',
            des:'火灾预防及报警实时监控，多级平台联动处置',
            icon: '/images/product/pd-4-1-3/1.png',
            content:'近年来，随着社会的发展进步，城市高层、大型建筑和各类场所单位日益增多，消防安全形势异常严峻，消防安全监督管理部门人员有限，消防安全监管缺乏有效的技术手段支撑和社会化手段配合，无法及时发现、消除、整改重大火险隐患，火灾风险和发生几率仍然居高不下。',
            list: [
              {
                title: '背景概述',
                list: [
                  {
                    type: 'content',
                    model: 3, //3段落间隔加大
                    list: [
                      '近年来，随着社会的发展进步，城市高层、大型建筑和各类场所单位日益增多，消防安全形势异常严峻，消防安全监督管理部门人员有限，消防安全监管缺乏有效的技术手段支撑和社会化手段配合，无法及时发现、消除、整改重大火险隐患，火灾风险和发生几率仍然居高不下。',
                      '2020年《全国安全生产整治三年行动计划》在消防安全整治中要求：积极推广应用消防安全物联网监测、消防大数据分析研判等信息技术，推动建设基层消防网格信息化管理平台，2021年底前地级以上城市建成消防物联网监控系统，2022年底前分级建成城市消防大数据库。',
                      '2020年《消防安全专项整治三年行动实施方案》要求：全面应用大数据、物联网信息化技术，依托智慧城市建设，分级建成城市消防大数据库，实时化、智能化评估消防安全风险。2022年底前，全国火灾监测预警预报平台基本建成，差异化精准监管全面推行。'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/1.png',
                    ]
                  }
                ]
              },
              {
                title: '适用场景',
                haveBg:true,
                list: [
                  {
                    type: 'content',
                    model: 1, //3段落间隔加大
                    list: [
                      '智慧消防监管平台覆盖范围广泛、涉及领域众多，适用于工业园区、消防支队、消防大队、小区物业、九小场所、商业综合体、物流储运等人员密集、消防重点保护单位及消防救援、消防责任主体单位。'
                    ]
                  },
                ]
              },
              {
                title: '功能点',
                list: [
                  {
                    type: 'card-row',
                    model: 'circle',
                    gutter: 30,
                    colSpan: 8,
                    list: [
                      {
                        title: '',
                        img: '/images/product/pd-4-1-3/icon-17-1.png',
                        content: [
                          '分级监管、全网监控',
                          '在线监测情景预警'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-3/icon-17-2.png',
                        content: [
                          '报警联动、警情处置',
                          '提升火灾处置能力'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-3/icon-17-3.png',
                        content: [
                          '安全评分、智能分析',
                          '强化风险防控能力'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-3/icon-17-4.png',
                        content: [
                          '巡查治理、隐患跟踪',
                          '实现管理责任落实'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-3/icon-17-5.png',
                        content: [
                          '教育培训、安全演练',
                          '加强安全教育及风险防范'
                        ]
                      },
                      {
                        title: '',
                        img: '/images/product/pd-4-1-3/icon-17-6.png',
                        content: [
                          '实时监测、设备管理',
                          '直观设备状态及报警趋势'
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                title: '实施效果',
                haveBg: true,
                list: [
                  {
                    type: 'content',
                    model: 1,
                    list: ['从火灾预防，到火情报警，再到控制联动，均在统一的系统平台内运行，用户通过平台直观查看各类消防设备和传感器的运行状况，并能够展示隐患细节，在发生火情时能够迅速通知至相关人员。功能模块包括全网监控、警情监控、隐患跟踪、统计分析、设备监管、报警处理、消防资源、培训演练等。']
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '全网监控'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['为省、市、区县、乡镇街道、社区居委会等不同级别政府部门快速构建“智慧城市”、“平安城市”的科学决策提供数据支撑与基础保障。对城市消防安全管理工作提供决策提供信息数据支持，同时能够有效控制不断上升的城市消防安全风险，建立有效的技术监管手段，提高防患于未然的能力，提升政策执行能力和决策水平，从而带动可观的经济效益，促进全面消防工作开展。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/2.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '警情监控'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['监管单位所辖行业单位出现告警现象时，立即弹出告警推送信息，警情信息中详细记录报警单位、报警时间、具体位置、企业负责人等基础信息；通过报警数量、隐患数量、离线设备数量等维度计算单位安全评分，并将分数低于安全线的单位视为高危单位进行展示，以便重点关注。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/3.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '隐患跟踪'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['行业单位在执行巡查任务时产生的异常巡查结果被视为隐患信息同步至消防监管平台，监管单位可直观查看隐患高发单位、隐患上报时间、当前隐患状态、隐患整改进度、隐患描述等隐患详细信息。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/4.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '统计分析'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['全方位针对设备类型、设备状态、隐患状态、报警趋势等进行实时统计及信息反馈，通过对各类数据的汇总记录，可定期生成统计报表供管理人员参考分析。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/5.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '设备监管'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['对接入单位的消防设备进行全程监控，通过系统可随时查看设备状态、报警设备、设备所属系统、设备详细地址等信息。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/6.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '报警处理'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['与警情单位进行初步沟通后，可在消防监管平台针对目标行业单位出现的报警信息进行处理操作。通过已出警、误报及已解决等处理状态的操作后，可完全消除警情单位的消防隐患，保证警情误报时不松懈、出现警情时不延误。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/7.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '消防资源'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['通过消防监管平台可进行公共消防资源如消防单位、疏散场所、医院及消防水源等录入操作，以便在所辖单位发生警情时可快速直观的查看并有效调用其单位周边的消防资源设施，尽最大可能减小人员及财产的损失。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/8.png',
                    ]
                  },
                  {
                    type: 'headline',
                    icon:'',
                    content: '培训演练'
                  },
                  {
                    type: 'content',
                    model: 1,
                    list: ['虽然社会发展科学进步飞速，但人们的消防安全意识仍很淡薄，对火灾的麻痹和侥幸心理还普遍存在，透过消防应急演练，可提高居民的安全应急意识，到达在发生火灾时，居民能够采取正确的方法自救、互救、有序、安全地撤离、疏散、扑火，最大限度地减少人员伤亡的目的。']
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-3/9.png',
                    ]
                  },
                ]
              }
            ]
          },
          {
            id:'4-1-4',
            name: '燃气安全监测',
            menuIcon: '/images/menu/prod/icon-4-1-4.png',
            des:'构建燃气管网综合管理的动态监测网络，提升经营管理效率',
            icon: '/images/product/pd-4-1-4/1.png',
            content: '燃气管网监测系统构建燃气管网综合管理的动态监测网络，通过增加智能传感器，利用物联网技术，实现对压力、流量、密闭空间、燃气泄漏等数据监测，实时记录和分析管网运行健康数据，实现燃气管网地理空间、运行状态信息的集成以及管网运行状态的动态安全监管。通过系统建设，可提供可靠、有效、有用的自动化在线监测技术手段，提升经营管理效率。同时，燃气管网监测系统能加强燃气管网安全监控，提升危险报警响应时间，通过对燃气管网监测数据的分析，能够很好的进行气源调度，快速处置燃气管网突发报警事件。智慧燃气管网监测系统适用于城市各种燃气管线、主干线、支线；适用于郊外、长输管线、城市燃气调压柜、调压站等监测。',
            list: [
              {
                title: '背景概述',
                list: [
                  {
                    type: 'content',
                    model: 1, //3段落间隔加大
                    list: [
                      '燃气管网监测系统构建燃气管网综合管理的动态监测网络，通过增加智能传感器，利用物联网技术，实现对压力、流量、密闭空间、燃气泄漏等数据监测，实时记录和分析管网运行健康数据，实现燃气管网地理空间、运行状态信息的集成以及管网运行状态的动态安全监管。通过系统建设，可提供可靠、有效、有用的自动化在线监测技术手段，提升经营管理效率。同时，燃气管网监测系统能加强燃气管网安全监控，提升危险报警响应时间，通过对燃气管网监测数据的分析，能够很好的进行气源调度，快速处置燃气管网突发报警事件。智慧燃气管网监测系统适用于城市各种燃气管线、主干线、支线；适用于郊外、长输管线、城市燃气调压柜、调压站等监测。'
                    ]
                  },
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 20,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-4/1.png',
                    ]
                  }
                ]
              },
              {
                title: '系统组成',
                haveBg: true,
                list: [
                  {
                    type: 'content',
                    model: 3,
                    list: [
                      '燃气管网监测系统综合管理智能平台，可对燃气管网数据的统一管理，实现对日常巡查、养护、应急指挥的全流程精细化管理，为管网新建、升级、改建规划方案提供数据基础；系统组成城市燃气管网监测系统总体架构由感知层、传输层、数据层、服务层、应用层以及标准规范和运行保障体系组成。',
                    ]
                  },
                  {
                    type: 'order',
                    model: 4,
                    list:[
                      {
                        index: '',
                        title: '感知层：',
                        content: '燃气管网监测系统的感知层主要由无线气体探测器、物联网网关及相关传感器组成。系统感知层是燃气管网监测系统的关键部分，是系统基础数据来源，通过前端设备实现燃气管网监测参数采集，通过可靠的传输网络将采集参数进行远程传输。'
                      },
                      {
                        index: '',
                        title: '网络层：',
                        content: '是数据通信的核心，是数据传输的主要通道，网络层主要采用NB-IoT、4G、5G等通信网络。'
                      },
                      {
                        index: '',
                        title: '服务层：',
                        content: '由物联网设备管理平台组成，实现数据的汇集与管理，为管网监测平台及其他应用平台提供专业、便捷的数据接口服务。'
                      },
                      {
                        index: '',
                        title: '应用层：',
                        content: '由智慧管网监测平台或第三方业务管理平台组成，实现设备管理、报警信息管理、大数据分析、水力模型分析、管网分析等功能。'
                      }
                    ]
                  },
                ]
              },
              {
                title: '系统拓扑图',
                list: [
                  {
                    type: 'img',
                    imgType: 1,
                    colSpan: 24,
                    gutter: 0,
                    list: [
                      '/images/product/pd-4-1-4/1.png',
                    ]
                  },
                ]
              },
              {
                title: '系统特点',
                haveBg: true,
                list: [
                  { // 无序排列
                    type: 'disorder',
                    model: 1,
                    list: [
                      '采集燃气管道压力、温度、流量、气体泄漏等数据',
                      '多种信息上报方式：定时上报和监测数据超限上报',
                      '支持对各种类型仪表对接功能',
                      '支持历史数据查询功能，报表生成功能，自动生成各种报表',
                      '易维护性，系统操作简便，抄表终端支持远程维护管理',
                      '采用5G/4G/GPRS等多种无线通信方式',
                      '现场可存储、显示、查询压力、流量等数据及工作参数',
                      '数据存储间隔、数据上报间隔可以设置',
                      '支持远程升级设备程序、设定参数',
                    ]
                  },
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/views/product/productInfo.js